// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const TagCustomerIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        fillRule="evenodd"
        d="M22.03 8.49 18.78 3.7c-.5-.74-1.35-1.19-2.25-1.19H7.48c-.9 0-1.74.45-2.25 1.2L1.97 8.48c-.7 1.04-.61 2.42.24 3.37l8.07 8.86c.44.48 1.07.76 1.72.76s1.28-.28 1.71-.76l8.08-8.87c.85-.94.95-2.32.24-3.36"
        opacity=".5"
      />
      <path d="M8.55 12.98q.31 0 .55-.22c.34-.3.37-.83.06-1.17L7.14 9.38c-.3-.34-.83-.36-1.17-.05-.34.3-.36.83-.05 1.17l2.01 2.2q.26.28.62.28" />
    </g>
  </SvgIcon>
);

export default TagCustomerIcon;
